/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const backToTop = (() => {

  const DOM = {};
  let scrollPos = 50;

  const cacheDOM = () => {
    DOM.backtotop = document.getElementById('back-to-top');
  };

  const showButton = () => {
    let windowY = window.scrollY;
    if (windowY > scrollPos) {
      DOM.backtotop.classList.add('visible');
    }
  };

  const eventListeners = () => {
    window.addEventListener('scroll', showButton);
  };

  function init() {
    cacheDOM();
    eventListeners();
  }

  return {
    init
  };
})();

export default backToTop;
